import * as inklineIcons from "@inkline/inkline/icons";
import { InklineIconsKey } from "@inkline/inkline/constants";
export const IconsPlugin = {
  install: (app, { icons } = { icons: {} }) => {
    app.provide(InklineIconsKey, {
      ...inklineIcons,
      ...icons
    });
  }
};
